import React from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'
import styles from './PrivilegeCheckbox.module.css'
import PrivilegeTooltipWrapper from '../PrivilegeTooltipWrapper/PrivilegeTooltipWrapper'

export default function PrivilegeCheckbox ({ privilege, privilegesBlockingUnchecking, checked, onChange, disabled, bottomContent }) {
  const { t } = useTranslation()

  const isCheckboxBlocked = privilegesBlockingUnchecking?.length > 0

  const isDisabled = disabled || isCheckboxBlocked

  return (<PrivilegeTooltipWrapper show={isCheckboxBlocked} privileges={privilegesBlockingUnchecking}>
      <div className={styles.privilege}>
        <label className={isDisabled ? '' : 'cursorPointer'}>
          <PrimaryCheckbox
            disabled={isDisabled}
            name={'privileges'}
            type="checkbox"
            value={privilege}
            checked={checked}
            onChange={onChange}
            className={styles.checkbox}
          />{' '}
          <span className={styles.text}>
            {t('privileges.' + privilege)}
          </span>
        </label>
        {bottomContent}
      </div>
    </PrivilegeTooltipWrapper>
  )
}
